<div class="notification">
  <i class="material-icons" [class]="state">{{ icon }}</i>
  <div class="column">
    <div class="title" [class]="state">
      <span [class.uppercase]="upper">{{ title }}</span>
    </div>
    <div class="content">{{ content }}</div>
  </div>
</div>
